// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageApertureDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12.0311 22C15.044 21.9908 17.7432 20.6492 19.5707 18.5336L16.8259 13.9607L12.0311 22ZM16.1576 8.96094L20.8166 16.7231C21.5717 15.3165 22 13.7082 22 12C22 10.9404 21.8352 9.91931 21.5298 8.96094H16.1576ZM10.1318 8.96094H13.825L15.6579 12.0146L13.8773 15H10.145L8.31496 11.9677L10.1318 8.96094ZM7.80898 15L3.16679 7.30808C2.42203 8.70728 2 10.3044 2 12C2 13.0452 2.16035 14.053 2.4578 15H7.80898ZM3.33782 17C4.72071 19.3906 7.06482 21.1556 9.84166 21.7665L12.6845 17H3.33782ZM9 6.96672L7.14728 10.0329L4.40697 5.49235C6.24098 3.35444 8.96232 2 12 2H12.0011L9.00349 6.96094H9V6.96672ZM14.1922 2.24103C16.9391 2.8554 19.2594 4.59988 20.6395 6.96094H11.3402L14.1922 2.24103Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM26.7746 24.9398C24.2065 28.0314 20.3332 30 16 30L15.9899 30L21.7372 19.9672L21.7341 19.9654L22.8396 18.0306L26.7746 24.9398ZM28.0481 23.1347C29.2881 21.0453 30 18.6058 30 16C30 14.2384 29.6746 12.5528 29.0807 11H21.1429L24 16L23.9924 16.0134L28.0481 23.1347ZM17.695 23L13.7848 29.8257C9.54626 29.1519 5.9415 26.5759 3.87295 23H17.695ZM18.8394 21L21.6898 16.0117L18.8757 11.0705L18.8787 11.0688L18.8394 11H13.1609L10.3035 16L10.8197 16.9033L12.7748 20.3127L12.7696 20.3157L13.1606 21H18.8394ZM9.14882 13.9896L15.9998 2C11.65 2.00005 7.76355 3.98386 5.19579 7.09607L9.14882 13.9896ZM3.928 8.90569L9.08388 17.8968L10.8571 21H2.91926C2.32536 19.4472 2 17.7616 2 16C2 13.411 2.70279 10.9861 3.928 8.90569ZM14.3037 9L18.2047 2.1726C22.4478 2.84379 26.0568 5.42115 28.127 9H14.3037Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageApertureDefault is a generated icon component.
 */
let IconImageApertureDefault = IconImageApertureDefault_1 = class IconImageApertureDefault extends IconBaseElement {
    render() {
        return html `${IconImageApertureDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageApertureDefault.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconImageApertureDefault = IconImageApertureDefault_1 = __decorate([
    customElement('zui-icon-image-aperture-default')
], IconImageApertureDefault);
export { IconImageApertureDefault };
